export const saveProductDto = {
  fileCapa: null, // File
  fileCard: null, /// File
  ativo: null, // bool
  cargaHoraria: null, // number
  idPortfolio: null,
  descricao: null,
  exigeLoginPrevioTelegram: null,
  exigeLoginPrevioWhatsapp: null,
  funcionalidades: [], // {ativo: bool, id: string (required) , nome: string}
  linkAcessoTelegram: null,
  linkAcessoWhatsapp: null,
  modulos: [], // string
  nome: null, // string
  objetivo: null, // string
  publicos: [], // {ativo: bool, id: string (required) , nome: string}
  tags: [], // string
  temas: [], // {ativo: bool, id: string (required) , nome: string, isSas: number}
  tipoProduto: {
    id: null, // string
    nome: null, // string
    ativo: null, // bool
  },
  urlVideoMarketing: null, // string
  valor: null, // number
  tempoRealizacao: null, // number
  imageCapaUpdated: null, // boolean
  imageCardUpdated: null, // boolean
  idDisponibilizacao: null,
  codigoDisponibilizacaoSas: null,
  codigoProdutoSas: null,
};

const convertFile = {
  tipoProduto: true,
  publicos: true,
  tags: true,
  temas: true,
  modulos: true,
  funcionalidades: true,
};

// eslint-disable-next-line sonarjs/cognitive-complexity
const handleInsertion = (chave, prop, form) => {
  if (Array.isArray(prop)) {
    for (let i = 0; i < prop?.length; i++) {
      if (prop[i]?.id) {
        form.append(`${chave}[${i}].id`, prop[i].id);
      } else {
        form.append(`${chave}`, prop[i]);
      }
    }
  } else {
    form.append(`${chave}.id`, prop.id);
  }
};

export const saveProductFormData = (produto) => {
  const formData = new FormData();
  for (let pro in produto) {
    addFormData(pro, produto, formData);
  }
  return formData;
};

function addFormData(pro, produto, formData) {
  if (produto[pro] != null) {
    if (pro in convertFile) {
      handleInsertion(pro, produto[pro], formData);
    } else {
      formData.append([pro], produto[pro]);
    }
  }
}
